import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import "./HelpSupport.css";
import { IoIosSearch } from "react-icons/io";
import emailIcon from "../../../assets/mage_email.png";
import callIcon from "../../../assets/callIcon.png";
import { IoCallOutline } from "react-icons/io5";
import { Button } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";
import { errorPopup, successPopup } from "../../../Utils/ToasterMessage";
import { Oval } from "react-loader-spinner";

const faqCategories = [
  { name: "Account Management", key: "accountManagement" },
  { name: "Job Postings", key: "jobPostings" },
  { name: "Applications", key: "applications" },
  { name: "Subscription & Payment", key: "subscriptionAndPayment" },
  { name: "Technical Support", key: "technicalSupport" },
  { name: "General Queries", key: "generalQueries" },
];

const allFaqsCollection = {
  accountManagement: [
    {
      question: "How do I create an account?",
      answer:
        "Click on the 'Sign Up' button and follow the steps to create your account.",
    },
    {
      question: "How can I update my account details?",
      answer:
        "Go to the 'Account Settings' page and edit the fields you want to update.",
    },
    {
      question: "How do I reset my account password?",
      answer: "Use the 'Forgot Password' link to receive a reset email.",
    },
    {
      question: "Can I temporarily deactivate my account?",
      answer:
        "Yes, you can deactivate your account from the 'Settings' page and reactivate it later.",
    },
    {
      question: "How do I manage user roles in my account?",
      answer:
        "Navigate to the 'Roles & Permissions' section to manage user roles.",
    },
  ],
  jobPostings: [
    {
      question: "How do I post a new job?",
      answer: "Click on 'Post a Job', fill in the job details, and submit.",
    },
    {
      question: "Can I edit a job posting after publishing?",
      answer:
        "Yes, you can edit a job posting by navigating to 'My Jobs' and selecting the job.",
    },
    {
      question: "How do I close a job posting?",
      answer: "Go to the job posting and select 'Close Job' to deactivate it.",
    },
    {
      question: "Can I duplicate an existing job posting?",
      answer:
        "Yes, use the 'Duplicate Job' option to quickly create a similar posting.",
    },
    {
      question: "How can I track the performance of my job postings?",
      answer:
        "Visit the 'Job Analytics' section to view metrics like views and applications.",
    },
  ],
  applications: [
    {
      question: "How do I view job applications?",
      answer:
        "Go to the 'Applications' tab under your job posting to see all submissions.",
    },
    {
      question: "Can I filter applications by status?",
      answer:
        "Yes, use the filters to sort applications by 'Pending', 'Reviewed', or 'Rejected'.",
    },
    {
      question: "How do I contact an applicant?",
      answer: "Click on the applicant's profile and use the 'Contact' button.",
    },
    {
      question: "Can I export application data?",
      answer:
        "Yes, you can export application data to a CSV file from the 'Applications' section.",
    },
    {
      question: "How do I set up auto-responses for applicants?",
      answer:
        "Use the 'Auto-Reply' feature under 'Settings' to configure responses.",
    },
  ],
  subscriptionAndPayment: [
    {
      question: "What subscription plans are available?",
      answer:
        "We offer monthly, quarterly, and annual plans with different features.",
    },
    {
      question: "How do I update my payment method?",
      answer:
        "Go to 'Billing' under 'Account Settings' and add a new payment method.",
    },
    {
      question: "Can I get a refund for my subscription?",
      answer:
        "Refunds are available within 14 days of purchase for eligible plans.",
    },
    {
      question: "How do I view my billing history?",
      answer:
        "Navigate to 'Billing History' in the 'Account Settings' section.",
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept credit cards, PayPal, and bank transfers.",
    },
  ],
  technicalSupport: [
    {
      question: "How do I report a technical issue?",
      answer:
        "Go to the 'Support' page and submit a ticket with details of the issue.",
    },
    {
      question: "Can I get 24/7 technical support?",
      answer: "Yes, our premium plan includes 24/7 technical support.",
    },
    {
      question: "How do I reset my account if it's locked?",
      answer: "Contact technical support to unlock your account.",
    },
    {
      question: "How do I check the system status?",
      answer:
        "Visit the 'System Status' page to view real-time service updates.",
    },
    {
      question: "What should I do if the website is down?",
      answer:
        "Check the 'System Status' page first, then contact support if necessary.",
    },
  ],
  generalQueries: [
    {
      question: "Where can I find the company terms and policies?",
      answer:
        "You can find our terms and policies in the 'About' section of the website.",
    },
    {
      question: "How do I update my contact information?",
      answer: "Go to 'Profile Settings' and update your contact details.",
    },
    {
      question: "Can I request a demo of your product?",
      answer: "Yes, you can request a demo through the 'Contact Us' page.",
    },
    {
      question: "What is the response time for customer support?",
      answer: "Our average response time is within 24 hours on business days.",
    },
    {
      question: "How do I provide feedback about the platform?",
      answer:
        "Use the 'Feedback' form in the 'Help Center' to share your thoughts.",
    },
  ],
};

const options = [
  { value: "accountManagement 0", label: "How do I create an account?" },
  {
    value: "accountManagement 1",
    label: "How can I update my account details?",
  },
  {
    value: "accountManagement 2",
    label: "How do I reset my account password?",
  },
  {
    value: "accountManagement 3",
    label: "Can I temporarily deactivate my account?",
  },
  {
    value: "accountManagement 4",
    label: "How do I manage user roles in my account?",
  },

  { value: "jobPostings 0", label: "How do I post a new job?" },
  {
    value: "jobPostings 1",
    label: "Can I edit a job posting after publishing?",
  },
  { value: "jobPostings 2", label: "How do I close a job posting?" },
  { value: "jobPostings 3", label: "Can I duplicate an existing job posting?" },
  {
    value: "jobPostings 4",
    label: "How can I track the performance of my job postings?",
  },

  { value: "applications 0", label: "How do I view job applications?" },
  { value: "applications 1", label: "Can I filter applications by status?" },
  { value: "applications 2", label: "How do I contact an applicant?" },
  { value: "applications 3", label: "Can I export application data?" },
  {
    value: "applications 4",
    label: "How do I set up auto-responses for applicants?",
  },

  {
    value: "subscriptionAndPayment 0",
    label: "What subscription plans are available?",
  },
  {
    value: "subscriptionAndPayment 1",
    label: "How do I update my payment method?",
  },
  {
    value: "subscriptionAndPayment 2",
    label: "Can I get a refund for my subscription?",
  },
  {
    value: "subscriptionAndPayment 3",
    label: "How do I view my billing history?",
  },
  {
    value: "subscriptionAndPayment 4",
    label: "What payment methods do you accept?",
  },

  { value: "technicalSupport 0", label: "How do I report a technical issue?" },
  { value: "technicalSupport 1", label: "Can I get 24/7 technical support?" },
  {
    value: "technicalSupport 2",
    label: "How do I reset my account if it's locked?",
  },
  { value: "technicalSupport 3", label: "How do I check the system status?" },
  {
    value: "technicalSupport 4",
    label: "What should I do if the website is down?",
  },

  {
    value: "generalQueries 0",
    label: "Where can I find the company terms and policies?",
  },
  {
    value: "generalQueries 1",
    label: "How do I update my contact information?",
  },
  { value: "generalQueries 2", label: "Can I request a demo of your product?" },
  {
    value: "generalQueries 3",
    label: "What is the response time for customer support?",
  },
  {
    value: "generalQueries 4",
    label: "How do I provide feedback about the platform?",
  },
];

export default function HelpSupport() {
  const [queryForm, setQueryForm] = useState({ subject: "", message: "" });
  const [error, setError] = useState({ subject: "", message: "" });
  const [allQue, setAllQue] = useState({ key: "", index: "0" });
  const [selectedOption, setSelectedOption] = useState(null);
  const [respSelectmenu, setRespSelectmenu] = useState("");
  const [activeCatTag, setActiveCatTag] = useState(faqCategories[0] || {});
  const [loader, setLoader] = useState(false);

  const handleSearchSumbit = (e) => {
    e.preventDefault();
  };

  const handleQueryForm = (type, e) => {
    setQueryForm((prev) => ({ ...prev, [type]: e.target.value }));
    setError((prev) => ({ ...prev, [type]: "" }));
  };

  const isValidForm = () => {
    if (!queryForm?.subject) {
      setError((prev) => ({ ...prev, subject: "Subject is required." }));
      return false;
    }
    if (queryForm?.subject?.split(" ")?.length < 2) {
      setError((prev) => ({
        ...prev,
        subject: "Subject should not be less than 3 words.",
      }));
      return false;
    }

    if (!queryForm.message) {
      setError((prev) => ({ ...prev, message: "Message is required." }));
      return false;
    }

    if (queryForm?.message?.split(" ")?.length < 20) {
      setError((prev) => ({
        ...prev,
        message: "Message should not be less than 20 words.",
      }));
      return false;
    }
    return true;
  };

  const handleSubmitQueryForm = (e) => {
    e.preventDefault();
    if (isValidForm()) {
      setLoader(true);
      axios
        .post(
          `${COMPANY_URLS.queryToAdmin}`,
          {
            title: queryForm?.subject,
            description: queryForm?.message,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          successPopup(response?.data?.message);
          setQueryForm({ subject: "", message: "" });
        })
        .catch((error) => {
          errorPopup(error?.response?.data?.message);
        })
        .finally(() => setLoader(false));
    }
  };

  const handleClick = (activetagItem) => {
    setActiveCatTag(activetagItem);
    setSelectedOption({ value: "", label: "" });
  };

  const handleSabMenu = (e) => {
    setRespSelectmenu(e.value);
    setActiveCatTag({ name: e?.label, key: e.value });
  };

  const handleChange = (e) => {
    setSelectedOption(e.value);
    setActiveCatTag((prev) => ({
      ...prev,
      key: e.value?.split(" ")[0],
      name: e.value?.split(" ")[0],
    }));
    setAllQue((prev) => ({
      ...prev,
      key: e.value?.split(" ")[0],
      index: e.value?.split(" ")[1],
    }));
  };

  return (
    <>
      <h1 className="help_support_title mt-4">Help & Support</h1>
      <div className="main_support_container">
        <div className="helpNsupport_main d-flex gap-4 row">
          <div className="sub_navItems col-md-4">
            <form onSubmit={handleSearchSumbit} className="mb-4">
              {/* <div className='seachInput d-flex align-items-center'>
                <IoIosSearch />
                <input
                  type="text"
                  placeholder='Search your query'
                  value={inputSearch}
                  onChange={(e) => {
                    handleSearchChange(e)
                    setInputSearch(e.target.value)
                  }}
                />
              </div> */}
              <Select
                className="d-sm-none d-block"
                value={respSelectmenu?.label}
                onChange={handleSabMenu}
                // defaultInputValue={options.filter((data,idx)=>data.label===selectedOption.label)}
                // options={faqCategoriesForRes}
                options={faqCategories?.map((data, idx) => ({
                  label: data.name,
                  value: data.key,
                }))}
              />
              <Select
                className="d-sm-block d-none"
                value={selectedOption?.label}
                onChange={handleChange}
                // defaultInputValue={options.filter((data,idx)=>data.label===selectedOption.label)}
                options={options}
              />
            </form>
            <div className="categoryTag d-flex flex-column gap-3">
              {faqCategories?.map((items, idx) => (
                <p
                  onClick={() => handleClick(items)}
                  className={`m-0 catgory_items ${
                    activeCatTag?.key === items?.key && "active-faq-item"
                  }`}
                  key={idx}
                >
                  {items?.name}
                </p>
              ))}
            </div>
          </div>
          <div className="accordian_faqs col-md-8">
            <Accordion activeKey={allQue.index} defaultActiveKey={"0"}>
              {allFaqsCollection[activeCatTag?.key]?.map((data, idx) => (
                <Accordion.Item
                  onClick={() =>
                    setAllQue((prev) => ({
                      ...prev,
                      index: prev.index === String(idx) ? null : String(idx),
                    }))
                  }
                  eventKey={String(idx)}
                  key={idx}
                  className="mb-3"
                >
                  <Accordion.Header>{data?.question}</Accordion.Header>
                  <Accordion.Body className="pt-0">
                    {data?.answer}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
        <div className="row mt-4">
          <div className="needSupport col-md-6 d-flex flex-wrap flex-column align-items-start justify-content-center gap-3 px-3 py-3">
            <div className="flex-grow-1 w-100">
              <h1>Still Need a Support?</h1>
              <p>
                We’re here to help! If you have any questions, concerns, or need
                support, feel free to reach out to us.
              </p>
            </div>
            <div className="flex-grow-1 w-100">
              <h1 className="mb-2">Contact Us</h1>
              <p className="mb-2">
                <img className="emailIcon" src={emailIcon} alt="email icon" />{" "}
                kaamvala@support.com
              </p>
              <p>
                <img className="callIcon" src={callIcon} alt="call icon" /> +91
                767494939455
              </p>
            </div>
          </div>
          <div className="col-md-6 py-3 px-3 query_form">
            <h2>Send you query to Us</h2>
            <Form onSubmit={handleSubmitQueryForm}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Subject</Form.Label>
                <Form.Control
                  type="text"
                  value={queryForm?.subject}
                  onChange={(e) => handleQueryForm("subject", e)}
                  placeholder="Enter your query subject"
                  isInvalid={error?.subject}
                />
                {error?.subject && (
                  <Form.Text className="text-muted">{error?.subject}</Form.Text>
                )}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Write your message here..."
                  value={queryForm?.message}
                  onChange={(e) => handleQueryForm("message", e)}
                  isInvalid={error?.message}
                />
                {error?.message && (
                  <Form.Text className="text-muted">{error?.message}</Form.Text>
                )}
              </Form.Group>
              <Button
                variant="primary"
                type="submit"
                className="px-5 d-flex gap-1 align-items-center justify-content-center m-auto"
              >
                {loader && (
                  <Oval color="#fff" width={15} height={15} strokeWidth={3} />
                )}
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}
